import { Box } from '@mui/material';

const version = process.env.REACT_APP_VERSION ?? '';
const sha = process.env.REACT_APP_GIT_SHA ?? '';

export default function VersionBadge() {
  if (!version && !sha) return null;
  const label = [version && `v${version}`, sha && `(${sha})`].filter(Boolean).join(' ');
  return (
    <Box
      sx={{
        display: 'block',
        width: 'fit-content',
        ml: 'auto',
        mr: 1,
        mt: 1,
        px: 1,
        py: 0.25,
        fontSize: 11,
        fontFamily: 'monospace',
        color: 'text.secondary',
        opacity: 0.6,
        userSelect: 'none',
        pointerEvents: 'none',
      }}
    >
      {label}
    </Box>
  );
}
